<template>
  <div id="resetPasswordForm">
    <router-link :to="{ name: 'login' }" class="dialog-button">
      <v-icon v-if="isMobile" class="back-arrow">
        {{ $vuetify.icons.expand }}
      </v-icon>
    </router-link>
    <v-card class="reset-password-card">
      <div class="logo-container">
        <img src="/img/homewayz_logo_stacked.svg" alt="Homewayz-Logo">
      </div>
      <v-card-title>
        <v-flex xs12>
          <h2 style="text-transform: capitalize">
            reset password for homewayz
          </h2>
        </v-flex>
      </v-card-title>
      <v-form ref="resetPasswordForm" lazy-validation>
        <v-text-field v-model="email" :rules="emailRules" label="E-mail" />
      </v-form>
      <v-flex xs12 sm6 offset-sm3>
        <v-btn
          color="#897547"
          class="reset-password-button"
          @click="sendRequestForResetPassword()"
        >
          Send
        </v-btn>
      </v-flex>
    </v-card>
    <v-flex :class="{'dialog': !openDialog, 'hide': openDialog}">
      <v-dialog v-model="openDialog" class="reset-password-dialog" width="600px">
        <v-card>
          <v-card-text>We have sent instructions for how to reset your password. Thanks</v-card-text>
          <v-card-actions>
            <router-link :to="{ name: 'login' }" class="dialog-button">
              OK
            </router-link>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { emailRules } from '../../utils/formUtils'
import { resetPasswordRequest } from '../../services/commonService'

export default {
  data: () => ({
    showAlert: false,
    message: '',
    email: '',
    openDialog: false,
    emailRules
  }),
  computed: {
    ...mapState('common', ['isMobile'])
  },
  methods: {
    sendRequestForResetPassword() {
      if (this.$refs.resetPasswordForm.validate()) {
        resetPasswordRequest({ email: this.email })
        this.openDialog = true
      }
    }
  }
}
</script>
<style lang='sass'>
.reset-password-card
  padding: 2rem 5rem
  max-width: 80rem
  border-radius: 15px !important
  @media only screen and (max-width: 600px)
    box-shadow: none !important
    padding: 2rem
.logo-container
  margin-top: 3rem
  margin-bottom: 5rem
.logo-container img
  width: 320px
  max-width: 320px
  height: auto
  @media only screen and (max-width: 600px)
    width: 90%
.reset-password-button
  width: 100%
  margin-top: 4rem !important
  div
    color: $hwayzWhite !important
.dialog
  display: block
  z-index: 148484
  .hide
    display: none
.dialog-button
  background-color: $hwayzBrandGold !important
  color: $hwayzWhite !important
  font-weight: 200
  width: 100%
  height: 40px
  border-radius: 10px
  padding-top: 1rem
  margin: 1rem 0 2rem 0
.dialog-button:hover
  color: $hwayzWhite !important
.v-card__text
  padding: 5rem 0 2rem
.v-card__actions
  margin: 0 auto
  width: 150px
.back-arrow
  font-size: 4rem
  transform: rotate(90deg)
  position: absolute
  top: 3%
  left: 3%
  z-index: 2
</style>
